const faqs = [
  {
    q: '嫩草视频需要下载APP吗？',
    a: '不需要。嫩草视频是手机网页版，直接用浏览器打开即可观看，无需下载任何APP，节省手机存储空间，即开即看更便捷。',
  },
  {
    q: '播放会卡顿吗？画质怎么样？',
    a: '我们持续优化服务器性能，确保高清流畅播放不卡顿。支持自适应画质，在网络条件良好的情况下可享受超清观影体验。',
  },
  {
    q: '有哪些影视资源可以看？',
    a: '涵盖97视频、丝瓜视频、蓝莓视频、91在线视频等多渠道资源，包括电影、电视剧、综艺、动漫、纪录片等丰富内容，每日更新。',
  },
  {
    q: '需要注册会员才能看吗？收费吗？',
    a: '嫩草视频面向所有用户免费开放，无需注册即可浏览和观看全部内容。我们致力于提供便捷免费的观影服务。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900">
            常见问题
          </h2>
          <p className="mt-2 text-sm text-foreground-500 font-label">关于嫩草视频的常见疑问解答</p>
        </div>

        <div className="space-y-3">
          {faqs.map((item) => (
            <details
              key={item.q}
              className="group rounded-xl bg-background-100 border border-background-200/60 overflow-hidden cursor-pointer"
            >
              <summary className="flex items-center justify-between p-5 font-heading font-semibold text-sm md:text-base text-foreground-800 list-none">
                <span>{item.q}</span>
                <div className="w-6 h-6 flex items-center justify-center rounded-full bg-background-200 group-open:bg-primary-100 transition-colors ml-3 flex-shrink-0">
                  <i className="ri-arrow-down-s-line text-foreground-500 group-open:text-primary-600 transition-transform duration-300 group-open:rotate-180"></i>
                </div>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-sm text-foreground-600 font-label leading-relaxed">
                  {item.a}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}